export default "__VITE_ASSET__I9tnaSlM__"